<template>
  <div class="content_wrap">
      

    <div class="cjg_content" v-if="share && share.length">
      <p>我的自选股</p>
      <div class="level-table" v-for="(item, key) in share" :key="key">
        <ul class="level-table-1">
          <li>发布时间</li>
          <div>{{ item.createdAt }}</div>
        </ul>
        <ul class="level-table-1">
          <li>我的股票</li>
           <div>{{ item.name }}</div>
        </ul>
        <ul class="level-table-1">
          <li>我的购买价位</li>
           <div>{{ item.price }}</div>
        </ul>
        <ul class="level-table-1">
          <li>我的止盈价位</li>
           <div>{{ item.target_price }}</div>
        </ul>
        <ul class="level-table-1">
          <li>我的止损价位</li>
           <div>{{ item.stop_price }}</div>
        </ul>
    </div>
    </div>

    <div class="teacher_add_wrap yf-text_12" v-if="isTeacher && data.status !== 4">
      <p class="teacher_add_title">追加策略</p>
      <div class="edit_wrap">
        <y-quill-editor ref="myQuillEditor" v-model="content" :module="{ normalView: false }" height="108" />
      </div>
      <p class="tishi">注意：提交前请仔细检查，<a>提交后无法修改</a></p>
      <p class="check_wrap">
        <input @click="toWx = !toWx" type="checkbox" checked="checked" value="" /> <span> 推送此消息</span><i title="购买并绑定微信的用户可以收到此信息提醒" class="iconfont icon-bangzhu"></i>
        <input class="teacher_submit" @click="submit" :disabled="isLoading" type="button" :value="isLoading ? '提交中...' : '提交'" />
      </p>
    </div>

    <div class="my_celue_wrap" v-if="list && list.length > 0">
      <p>我的策略</p>
      <div class="celue_item" v-for="item in list" :key="item.id">
        <p class="add_time yf-text_12">追加时间：{{ item.createdAt }}</p>
        <div class="add_detail rich_text" v-html="item.content"></div>
      </div>
    </div>
    <div class="easy_info">
      <p class="info">特别提醒：</p>
      <p class="detail">所有内容和信息，仅代表个人观点，仅供阅读交流，不构成投资建议，不作为买卖依据，据此操作风险自负</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import EditorMixin from '@/mixins/EditorMixin'

export default {
  name: 'components-article-cjg-detail',
  mixins: [EditorMixin],
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      list: [],
      share: [],
      toWx: true,
      isLoading: false
    }
  },
  mounted () {
    for (let item of this.data.content) {
      if (item.type === 1 && item.content) {
        this.list.push(item)
      } else if (item.type === 2) {
        let share = JSON.parse(item.content)
        share.createdAt = item.createdAt
        share.id = item.id
        this.share.push(share)
      }
    }
  },
  methods: {
		submit () {
      if (!this.$isLogin() || !this.content) return false

			let params = {
        id: this.data.id,
        content: this.content,
        to_wx: this.toWx ? 0 : 0,
        to_room: 1,
        to_vip: 0
      }
      this.isLoading = true
			this.$axios._post('/Article/Append', params).then(resp => {
				this.$notify({
          title: '成功',
          message: '追加策略成功',
          type: 'success'
	    	})
        this.list = [{id: resp.id, content: this.content, type: 1, createdAt: moment().format('YYYY-MM-DD HH:mm:ss')}].concat(this.list)
        this.setContent('')
        this.isLoading = false
			}).catch(error => {
        console.log(error)
        this.isLoading = false
      })
		},
  },
  computed: {
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    }
  }
}
</script>

<style lang="less" scoped>
.content_wrap { padding-top: 33px;
	.cjg_content { width: 775px;  margin-bottom: 18px;
		> p { font-size: 14px; color: #666666; margin-bottom: 12px; font-weight: 600;}
		.cjg_title_wrap { overflow: hidden;   border-top: 1px solid #DDDDDD; border-left: 0px solid #DDDDDD; background: #f3f1f2;
			> div { width: 154px; height: 41px; color: #686667; font-size: 14px; font-weight: 600; border-right: 1px solid #DDDDDD; border-bottom: 1px solid #DDDDDD; text-align: left;padding-left: 30px; line-height: 41px;}
			> div:nth-child(1) { width: 154px;}
		}
		.cjg_detail_wrap {  overflow: hidden; border-left: 1px solid #DDDDDD;
			> div { width: 154px; height: 41px; border-right: 1px solid #DDDDDD; font-size: 14px; color: #666666;  border-bottom: 1px solid #DDDDDD; text-align: center; line-height: 41px;}
			> div:nth-child(1) { width: 158px;}
		}
	}

	.teacher_add_wrap { width: 774px; height: 284px; border: 1px solid #d0d0d0; background: #ededed; padding: 0 20px; padding-top: 18px;
		.teacher_add_title { font-size: 14px; color: #666666; font-weight: 600; margin-bottom: 15px;}
		.edit_wrap { width:734px ; height: 152px; }
		.tishi { height: 40px; line-height: 40px; color: #666666;
			a { color: #e23c3c;}
		}
		.check_wrap {  position: relative;
			input { vertical-align: -25%; outline: none; }
			span { vertical-align: middle; }
			i { vertical-align: -18%; font-size: 14px; display: inline-block; color: #333; margin-left: 5px; }
			.teacher_submit { position: absolute; width: 107px; height: 31px; background: #e43a3d; color: #fff; border: none; right:18px ; top: -5px; cursor: pointer; }
		}
	}

	.my_celue_wrap { margin-top: 10px;
		> p { font-size: 14px; color: #666666; font-weight: 600; margin-bottom: 20px;}
		.celue_item { margin-bottom: 30px;
			.add_time { height: 30px; line-height: 30px; color: #ff0101; background: #f3f1f2; text-indent: 14px; margin-bottom: 14px;}
			.add_detail { word-break: break-all; }
		}
		img { max-width: 100%;}
	}
}
.level-table {
    padding: 1px; background-color: #f3ebe7;
    ul {
      overflow: hidden;
      li {
        float: left; line-height: 40px; margin-right: 1px; height: 40px; text-align: center;
        &:last-child {
          margin-right: 0;
        }
      }
      &:not(:first-child) {
        margin-top: 1px;
        li:not(:first-child) {
          font-size: 14px;
        }
      }
      &.level-table-1 {
        li {
          width: 150px; background-color: #ffffff;
          &:first-child {
            background-color: #faf7f5; text-align: left; padding-left: 23px; color: #666666; font-weight: 600; font-size: 14px;
          }
        }
        div{
          background-color: #ffffff;line-height: 40px;height: 40px;padding-left: 170px;
        }
        &:first-child {
          li:not(:first-child) {
            color: #666666;
            i {
              vertical-align: -7%;
            }
          }
        }
      }
    }
  }
  .easy_info { padding-top: 7px;
	.info { line-height: 44px; font-size: 16px; color: #666; font-weight: 600; }
	.detail { line-height: 25px; font-size: 14px; text-indent: 28px; color: #666; word-break: break-word; }
}
</style>
